import { render } from "./DeviceImagesAddComponent.vue?vue&type=template&id=5881711e&scoped=true"
import script from "./DeviceImagesAddComponent.vue?vue&type=script&lang=js"
export * from "./DeviceImagesAddComponent.vue?vue&type=script&lang=js"

import "./DeviceImagesAddComponent.vue?vue&type=style&index=0&id=5881711e&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5881711e"]])

export default __exports__